// Product photography, bundled with the app (no third-party requests). Each flavour was shot on its own colour; the
// card and product page use that same colour (`bg`) so the macaron sits on one seamless field. Pure lookup, unit-tested.
import vanilla from './assets/photos/vanilla-dream.jpg';
import chocolate from './assets/photos/chocolate-bliss.jpg';
import raspberry from './assets/photos/raspberry-rose.jpg';
import pistachio from './assets/photos/pistachio-paradise.jpg';
import lemon from './assets/photos/lemon-zest.jpg';
import lavender from './assets/photos/lavender-honey.jpg';
import caramel from './assets/photos/salted-caramel.jpg';
import matcha from './assets/photos/matcha-green-tea.jpg';
import passion from './assets/photos/passion-fruit.jpg';
import earlGrey from './assets/photos/earl-grey.jpg';
import hazelnut from './assets/photos/hazelnut-praline.jpg';
import cassis from './assets/photos/blackcurrant-violet.jpg';
import hero from './assets/photos/hero.jpg';
import giftBox from './assets/photos/gift-box.jpg';
import kitchen from './assets/photos/kitchen.jpg';
import flatlay from './assets/photos/flatlay.jpg';

// bg = the backdrop colour sampled from the photo's edges; ink = a text colour with at least 4.5:1 contrast on it.
const PRODUCTS = {
  'vanilla-dream': { src: vanilla, bg: '#eec15f', ink: '#1a0d0a' },
  'chocolate-bliss': { src: chocolate, bg: '#db552f', ink: '#1a0d0a' },
  'raspberry-rose': { src: raspberry, bg: '#e85577', ink: '#1a0d0a' },
  'pistachio-paradise': { src: pistachio, bg: '#8fa44f', ink: '#1a0d0a' },
  'lemon-zest': { src: lemon, bg: '#f3ba1d', ink: '#1a0d0a' },
  'lavender-honey': { src: lavender, bg: '#a885d2', ink: '#1a0d0a' },
  'salted-caramel': { src: caramel, bg: '#db7725', ink: '#1a0d0a' },
  'matcha-green-tea': { src: matcha, bg: '#6d8741', ink: '#1a0d0a' },
  'passion-fruit': { src: passion, bg: '#f28d20', ink: '#1a0d0a' },
  'earl-grey': { src: earlGrey, bg: '#8883a0', ink: '#1a0d0a' },
  'hazelnut-praline': { src: hazelnut, bg: '#c17d44', ink: '#1a0d0a' },
  'blackcurrant-violet': { src: cassis, bg: '#643c7f', ink: '#fff4e6' },
};

export const SCENES = { hero, giftBox, kitchen, flatlay };

// A flavour added to the catalogue before it has its own photo gets the flat lay on the product's own colour.
export function productPhoto(product) {
  const known = product && PRODUCTS[product.slug];
  if (known) return { ...known, generic: false };
  const color = product && /^#[0-9a-f]{6}$/i.test(product.color || '') ? product.color : '#e25c84';
  return { src: flatlay, bg: color, ink: '#1a0d0a', generic: true };
}
